import {useCommonComponentContext} from '@/context/ComponentContext';
import {Flex} from '@panda/jsx';

export const ModalLoading = () => {
	const {LoadingComponent} = useCommonComponentContext();
	return (
		<Flex
			zIndex={10}
			background="rgba(0,0,0,0.69)"
			backdropFilter="blur(1px)"
			justify="center"
			align="center"
			w="full"
			h="full"
			position="absolute"
			top="0"
			left="0"
			right="0"
			margin="auto">
			<LoadingComponent fill={false} />
		</Flex>
	);
};
